module.exports = __webpack_public_path__ + "img/8_73.1cef24ca.png";